export default __webpack_public_path__ + "static/media/trident-logo.69239ec4.png";